import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { PerformanceGauges } from './PerformanceGauges';
import { FileText, CheckCheck, Download } from 'lucide-react';

export const DailyProductivity = () => {
  return (
    <section className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-header-mb">
      {/* Personal Task Queue */}
      <Card className="col-span-1 xl:col-span-2">
        <CardHeader>
          <CardTitle className="text-lg font-bold text-brand-primary">My Priorities Today</CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          <div className="task-item">
            <div className="flex justify-between items-center text-xs mb-1">
              <p className="font-medium">Q3 VAT Declaration</p>
              <p className="text-destructive font-medium">Due in 2 days</p>
            </div>
            <Progress value={75} className="h-2.5" />
          </div>
          <div className="task-item">
            <div className="flex justify-between items-center text-xs mb-1">
              <p className="font-medium">Review August Transactions</p>
              <p className="text-muted-foreground">Due in 5 days</p>
            </div>
            <Progress value={40} className="h-2.5" />
          </div>
          <div className="task-item">
            <div className="flex justify-between items-center text-xs mb-1">
              <p className="font-medium">Export Payroll Data</p>
              <p className="text-muted-foreground">Due EOW</p>
            </div>
            <Progress value={90} className="h-2.5" />
          </div>
        </CardContent>
      </Card>

      {/* Performance Tracking */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-bold text-brand-primary">My Performance</CardTitle>
        </CardHeader>
        <CardContent className="flex justify-around items-center h-full -mt-4">
          <PerformanceGauges />
        </CardContent>
      </Card>

      {/* Client Snapshot */}
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-bold text-brand-primary">Client Snapshot</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-xs">
          <div className="flex items-center gap-2">
            <FileText className="w-4 h-4 text-muted-foreground" />
            <span className="font-medium">Special Rule:</span>
            <span>Exclude AMEX fees</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCheck className="w-4 h-4 text-muted-foreground" />
            <span className="font-medium">Checkpoint:</span>
            <span>Verify all travel expenses</span>
          </div>
          <div className="flex items-center gap-2">
            <Download className="w-4 h-4 text-muted-foreground" />
            <span className="font-medium">Export:</span>
            <span>Monthly Bexio Sync</span>
          </div>
        </CardContent>
      </Card>
    </section>
  );
};